import type { Product } from '../../../data/product';
import { formatDoh } from '../../../helpers/format-quantity';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const DOH: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'DOH',
  minWidth: 60,
  accessorFn: (product) => formatDoh(product.stats.days_on_hand),
  gloss: 'Days of inventory left at your average sales pace over the last 90 days.',
});
